import { c as _c } from "react/compiler-runtime";
import styles from "@components/table/projects/projects-table.module.css";
import { generateMemberProfileRoute, generateTeamDetailsRoute } from "@router/router-helper";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { getProjectManagerName } from "@utils/project-utils";
import { Link } from "react-router-dom";
/**
 * Component responsible for displaying the project manager's name as a clickable link or plain text.
 * The link redirects the user to either the member profile or team details, depending on the context.
 */
export function ProjectManagerDisplay(t0) {
  const $ = _c(16);
  const {
    project,
    companyId,
    canViewAllCompanyGroups
  } = t0;
  const projectManager = project.managers.projectManager;
  const projectManagerIdentity = projectManager?.identity ?? "";
  if (projectManager) {
    if (canViewAllCompanyGroups) {
      let t1;
      if ($[0] !== companyId || $[1] !== projectManager) {
        t1 = FaroCoreApiUtils.Member.isTeam(projectManager) ? generateTeamDetailsRoute(companyId, projectManager.identity) : generateMemberProfileRoute(companyId, projectManager.identity);
        $[0] = companyId;
        $[1] = projectManager;
        $[2] = t1;
      } else {
        t1 = $[2];
      }
      let t2;
      if ($[3] !== project) {
        t2 = getProjectManagerName(project);
        $[3] = project;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      let t3;
      if ($[5] !== t2) {
        t3 = <var>{t2}</var>;
        $[5] = t2;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      let t4;
      if ($[7] !== t1 || $[8] !== t3) {
        t4 = <Link to={t1} className={styles["removed-underline"]} onClick={_temp}>{t3}</Link>;
        $[7] = t1;
        $[8] = t3;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      return t4;
    } else {
      let t1;
      if ($[10] !== project) {
        t1 = getProjectManagerName(project);
        $[10] = project;
        $[11] = t1;
      } else {
        t1 = $[11];
      }
      let t2;
      if ($[12] !== t1) {
        t2 = <var>{t1}</var>;
        $[12] = t1;
        $[13] = t2;
      } else {
        t2 = $[13];
      }
      return t2;
    }
  } else {
    let t1;
    if ($[14] !== projectManagerIdentity) {
      t1 = <var>{projectManagerIdentity}</var>;
      $[14] = projectManagerIdentity;
      $[15] = t1;
    } else {
      t1 = $[15];
    }
    return t1;
  }
}
function _temp(e) {
  e.stopPropagation();
}